export default [
  {
    name: "Web Contract Agreement",
    value: 0,
  },
  {
    name: "SMS Job Confirm",
    value: 1,
  },
  {
    name: "SMS Job Complete",
    value: 2,
  },
  {
    name: "SMS Notification Job Confirm",
    value: 3,
  },
  {
    name: "SMS Notification Job Cancel",
    value: 4,
  },
  {
    name: "SMS Potential Customer",
    value: 5,
  },
  {
    name: "Web Job Cancel",
    value: 6,
  },
  {
    name: "Web Job Confirmation Message",
    value: 7,
  },
  {
    name: "Web Job Cancellation Message",
    value: 8,
  },
  {
    name: "Web Job Already Confirmed",
    value: 9,
  },
  {
    name: "Web Job Already Cancelled",
    value: 10,
  },
  {
    name: "Web Job Already Completed",
    value: 11,
  },
  {
    name: "Dispatch Job",
    value: 12,
  },
  {
    name: "Appointment Reminder SMS to Customer",
    value: 13,
  },
  {
    name: "Appointment Confirmation to Customer",
    value: 14,
  },
  {
    name: "Appointment Confirmation to Technician",
    value: 15,
  },
  {
    name: "Technician to Accept / Refuse",
    value: 16,
  },
];
